import MDataTableV2 from './MDataTableV2.vue';
import MDataTableCell from './MDataTableCell.vue';
import MDataTableColumn from './MDataTableColumn.vue';
import MDataTableHeaderV2 from './MDataTableHeaderV2.vue';
import MDataTableRow from './MDataTableRow.vue';
import MDataTableTop from './MDataTableTop.vue';

MDataTableV2.install = (app) => {
  app.component('MDataTableV2', MDataTableV2);
};

MDataTableCell.install = (app) => {
  app.component('MDataTableCell', MDataTableCell);
};

MDataTableColumn.install = (app) => {
  app.component('MDataTableColumn', MDataTableColumn);
};

MDataTableHeaderV2.install = (app) => {
  app.component('MDataTableHeaderV2', MDataTableHeaderV2);
};

MDataTableRow.install = (app) => {
  app.component('MDataTableRow', MDataTableRow);
};

MDataTableTop.install = (app) => {
  app.component('MDataTableTop', MDataTableTop);
};

export {
  MDataTableV2,
  MDataTableCell,
  MDataTableColumn,
  MDataTableHeaderV2,
  MDataTableRow,
  MDataTableTop,
};
